import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralize',
})
export class PluralizePipe implements PipeTransform {
  transform(value: number, singular: string, plural: string): any {
    if (value === 1) {
      return singular;
    } else {
      return plural;
    }
  }
}
